import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

const AlreadyMember = () => {
	return (
		<Box sx={{ display: 'flex' }}>
			<Typography component={'span'}>
				Already a member?{' '}
				<Link to="/login" style={{ textDecoration: 'none' }}>
					<Typography component={'span'} color="primary">
						Login
					</Typography>
				</Link>
			</Typography>
		</Box>
	);
};

export default AlreadyMember;
